import { ILocaleConfig } from "@/config/locale.config";
import { SupportedLocale, LocaleToLabelMap } from "@/enums/locale.enum";

// Spain-specific locale configuration
const spainLocaleConfig: ILocaleConfig = {
  supportedLocales: [
    SupportedLocale.ES,
    SupportedLocale.EN,
    SupportedLocale.RU,
  ],
  defaultLocale: SupportedLocale.ES,
  languageTabs: [
    {
      key: SupportedLocale.ES,
      label: LocaleToLabelMap.get(SupportedLocale.ES)!,
    },
    {
      key: SupportedLocale.EN,
      label: LocaleToLabelMap.get(SupportedLocale.EN)!,
    },
    {
      key: SupportedLocale.RU,
      label: LocaleToLabelMap.get(SupportedLocale.RU)!,
    },
  ],
};

export default spainLocaleConfig;
